import { Component, type ErrorInfo, type ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { reportError } from '@/app/common/utils/errorReporter.ts';

interface Props { children: ReactNode; }
interface State { hasError: boolean; }

export class AppErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, _info: ErrorInfo): void {
    reportError(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh" gap={2} p={4}>
          <Typography variant="h5" fontWeight={600}>Něco se pokazilo</Typography>
          <Typography color="text.secondary" textAlign="center">
            V aplikaci nastala neočekávaná chyba. Zkuste stránku obnovit.
          </Typography>
          <Button variant="contained" onClick={() => window.location.reload()}>Obnovit stránku</Button>
        </Box>
      );
    }
    return this.props.children;
  }
}
